import { ChartBarIcon } from "@heroicons/react/24/outline"
import { Route, Routes } from "react-router-dom"
import { useAuth } from "../../../context/authContext"
import { RouteElement } from "../../../interfaces/_common"
import { Unauthorized } from "../../Unauthorized"
import { SubMenuTabs } from "../common"
import { Dashboard } from "./Dashboard"
import { hasAccess } from "constants/permission.utils"
import RouteKeys from "constants/route-keys"

const _routes: RouteElement[] = [
    {
        title: 'Dashboard',
        component: Dashboard,
        route: '/',
        display: true,
        icon: ChartBarIcon,
        key: RouteKeys.HOME,
        end: true,
    }
]
const Home = () => {
    const auth = useAuth()
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                {
                        _routes.map(route => (
                            hasAccess(route.key, auth?.user?.permissions) ? <Route key={route.key} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                                : <Route key={route.key} path={route.route} element={<Unauthorized />} ></Route>
                        ))
                    }
                </Routes>
            </div>
        </div>
    )
}

export default Home